import axios from 'axios'
import store from '../store'
import { URL } from '../const'

import {
  // RESET_PUSH,
  FETCHING_PUSH,
  FETCH_PUSH_SUCCESS,
  FETCH_PUSH_FAIL,
  POSTING_PUSH,
  POST_PUSH_SUCCESS,
  POST_PUSH_FAIL,
  // DELETE_PUSH,
  SHOW_TOAST,
  HIDE_TOAST
  // SENDING_PUSH,
  // SEND_PUSH_SUCCESS,
  // SEND_PUSH_FAIL
} from '../actions/types'

export const fetchPush = () => async dispatch => {
  dispatch({ type: FETCHING_PUSH })

  // console.log('auth: ', auth)
  const headers = {
    'Authorization': `Token ${store.getState().user.token}`
  }
  const url = `${URL}push`
  try {
    const res = await axios.get(
      url,
      { headers }
    )
    // console.log('res: ', res)
    dispatch({
      type: FETCH_PUSH_SUCCESS,
      payload: res.data.events
    })
  } catch (error) {
    console.log('error: ', error)
    dispatch({ type: FETCH_PUSH_FAIL })
  }
}

export const savePush = (data, image) => async dispatch => {
  dispatch({ type: POSTING_PUSH })
  const url = `${URL}push`
  const config = {
    headers: {
      'Authorization': `Token ${store.getState().user.token}`,
      'Content-Type': 'multipart/form-data'
    }
  }
  // console.log('sending push: ', JSON.stringify(data))
  const formData = new FormData()
  formData.append('data', JSON.stringify(data))
  if (image) {
    const imageExtension = image.name.split('.').pop()
    const imageName = `push-${data.id || '000'}-${Date.now()}.${imageExtension}`

    // console.log('image: ', image)
    // console.log('imageName: ', imageName)
    formData.append('image', image, imageName)
  }
  try {
    await axios.post(
      url,
      formData,
      config
    )
    // console.log('res: ', res)
    dispatch({
      type: POST_PUSH_SUCCESS
    })
    showToast(dispatch, 'プッシュ保存しました！', 'primary')
  } catch (error) {
    console.log('error: ', error)
    showToast(dispatch, 'プッシュ保存失敗しました！', 'danger')
    dispatch({ type: POST_PUSH_FAIL })
  }
}

export const deletePush = (id, redirect) => async dispatch => {
  const headers = {
    'Authorization': `Token ${store.getState().user.token}`
  }
  const url = `${URL}push?id=${id}`
  try {
    const res = await axios.delete(
      url,
      { headers }
    )
    console.log('res: ', res)
    showToast(dispatch, '削除しました', 'danger')
    if (redirect) {
      redirect()
    }
  } catch (error) {
    console.log('error: ', error)
    showToast(dispatch, '削除失敗しました！！', 'danger')
  }
}

const showToast = function (dispatch, toastMessage, toastColor) {
  console.log('show')
  dispatch({
    type: SHOW_TOAST,
    payload: {
      toastMessage,
      toastColor
    }
  })

  setTimeout(() => {
    console.log('timeout')
    dispatch({ type: HIDE_TOAST })
  }, 3000)
}



// WEBPACK FOOTER //
// ./src/actions/pushActions.js